import { RouteConfig } from 'vue-router';

import { viewAddRoute } from './view/add.route';
import { viewEditRoute } from './view/edit.route';
import { viewsRoute } from './view/views.route';

export const viewContainerRoute: RouteConfig = {
  path: '/views',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [viewsRoute, viewAddRoute, viewEditRoute],
  meta: {
    breadcrumb: {
      title: 'Widoki',
      name: 'views'
    },
    config: {
      title: 'Widoki',
      name: 'views',
      icon: 'fa-image',
      permissions: ['VIEW.UPDATE']
    }
  }
};
